import api from '../../utils/api';

export interface PermissionState {
  id: number;
  userId: string | null;
  vendorId: string | null;
  userType: 'USER' | 'VENDOR';
  clientType: 'FLUTTER_USER_APP' | 'FLUTTER_PLUS_APP' | 'WEB_BROWSER';
  permissionName: string;
  status: 'GRANTED' | 'DENIED' | 'PERMANENTLY_DENIED' | 'RESTRICTED' | 'PROMPT';
  grantedAt: string | null;
  revokedAt: string | null;
  lastCheckedAt: string;
  deviceInfo: any;
  createdAt: string;
  updatedAt: string;
}

export interface PermissionAuditLog {
  id: number;
  userId: string | null;
  vendorId: string | null;
  userType: 'USER' | 'VENDOR';
  clientType: 'FLUTTER_USER_APP' | 'FLUTTER_PLUS_APP' | 'WEB_BROWSER';
  permissionName: string;
  eventType: 'GRANTED' | 'REVOKED' | 'DENIED';
  timestamp: string;
  deviceInfo: any;
  createdAt: string;
  updatedAt: string;
}

export interface FetchPermissionsResponse {
  success: boolean;
  data: {
    states: PermissionState[];
    auditLogs: PermissionAuditLog[];
  };
}

/**
 * Fetch permissions and audit logs for a user or vendor account
 * @param type 'user' or 'vendor'
 * @param id account ID
 */
export async function fetchPermissionsForAccount(
  type: 'user' | 'vendor',
  id: string
): Promise<FetchPermissionsResponse> {
  const response = await api.get<FetchPermissionsResponse>(`/master-admin/permissions/${type}/${id}`);
  return response.data;
}
